module.exports = __webpack_public_path__ + "static/media/pt.8ce156e0.svg";